































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { EditableFormatSummary, IEditableFormatStructure } from "../../../domain/editableFormat";
import { FormatDebuggableMixin } from "./mixins";

@Component
export default class FormatTranslatorTestTool extends Mixins(FormatDebuggableMixin) {
  @Prop()
  format: EditableFormatSummary;

  data() {
    return {
      source: null as any,
      structure: null as IEditableFormatStructure,
      translated: null as any,
      isComplemented: true,
      isEntityVisible: false,
      isLoading: false,
    };
  }
  source: any;
  structure: IEditableFormatStructure;
  translated: any;
  isComplemented: boolean;
  isEntityVisible: boolean;
  isLoading: boolean;

  get sourceAsString(): string {
    return this.stringifyOr(
      this.isComplemented ? this.complementedSource : this.source,
      "未読込");
  }

  get complementedSource(): any {
    return this.toComplementedSource(this.source);
  }

  get structureAsString(): string {
    return this.stringifyOr(
      this.structure,
      "未読込");
  }

  get translatedAsString(): string {
    return this.stringifyOr(
      this.isComplemented ? this.complementedTranslated : this.translated,
      this.structure ? "変換失敗" : "未読込");
  }

  get complementedTranslated(): any {
    return this.toComplementedSource(this.translated);
  }

  get hasDifference(): boolean {
    return !this.isLoading
        && !this.areEqual(this.complementedSource, this.complementedTranslated);
  }

  get status(): { message: string, class: string } {
    return this.isLoading
      ? {
        message: "読込中...",
        class: "",
      }
      : (this.hasDifference
        ? {
          message: "差異あり",
          class: "failed",
        }
        : {
          message: "差異なし",
          class: "success",
        });
  }

  mounted(): void {
    this.load();
  }

  private async load(): Promise<void> {
    this.isLoading = true;
    if (this.format) {
      const results = await Promise.all([
        await this.registry.formatEditorDeveloper.getFormatService().loadFormatStructureSource(this.format.id),
        await this.registry.editableFormat.getFormatRepository().getFormatStructure(this.format.id),
      ]);
      this.source = results[0];
      this.structure = results[1];
      this.translated = await this.registry.formatEditorDeveloper.getFormatService().translateFormatStructuteToSource(this.structure, false);
    }
    this.isLoading = false;
  }

  @Watch("format")
  onFormatUpdated(newValue: EditableFormatSummary, oldValue: EditableFormatSummary) {
    this.load();
  }
}
